import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installEasternTimeFormatOverride } from "./lib/eastern-time-format";
import {
  captureFrontendProductEvent,
  initializeFrontendPostHog,
} from "./lib/posthog";
import { installRuntimeApiBaseFetchBridge } from "./lib/runtime-api-base";
import "./index.css";

installEasternTimeFormatOverride();
installRuntimeApiBaseFetchBridge();
initializeFrontendPostHog();
captureFrontendProductEvent("application booted", {
  environment: import.meta.env.PROD ? "production" : "development",
  runtime: "electronAPI" in window ? "desktop" : "web",
  schema_version: 1,
});

// Suppress noisy third-party warnings (e.g. Snowplow "Invalid environment undefined")
const _origWarn = console.warn;
console.warn = (...args: unknown[]) => {
  if (
    args.some((a) => typeof a === "string" && a.includes("Invalid environment"))
  )
    return;
  _origWarn.apply(console, args);
};

const rootElement = document.getElementById("root")!;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const staticBoot = document.getElementById("fintheon-static-boot");
if (staticBoot) {
  const retireStaticBoot = () => {
    if (!rootElement.firstElementChild) return;
    staticBoot.dataset.retiring = "true";
    window.setTimeout(() => staticBoot.remove(), 460);
    observer.disconnect();
  };
  const observer = new MutationObserver(retireStaticBoot);
  observer.observe(rootElement, { childList: true });
  retireStaticBoot();
}

if (
  import.meta.env.PROD &&
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  window.location.hostname === "app.fintheon.io"
) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}
